<template>
	<div class="term_all_check">
		<!-- 전체 동의 체크박스 -->
		<div class="d_check">
			<input type="checkbox" v-model="allChecked" @change="toggleAll" id="allcheck" />
			<label for="allcheck">전체 약관 동의</label>
		</div>
	</div>

	<ul class="term_check_list">
		<li>
			<div class="d_check">
				<input type="checkbox" v-model="terms.checked" @change="updateTermsChecked" id="term" />
				<label for="term">{{ terms.text }}</label>
			</div>

			<button @click=openPopup1 class="btn_term_view">보기</button>
		</li>
		<li>
			<div class="d_check">
				<input type="checkbox" v-model="privacy.checked" @change="updatePrivacyChecked" id="privacy" />
				<label for="privacy">{{ privacy.text }}</label>
			</div>
			<button @click=openPopup2 class="btn_term_view">보기</button>
		</li>
		<!-- <li>
			<div class="d_check">
				<input
					type="checkbox"
					v-model="ecomm.checked"
					@change="updateEcommChecked"
					id="ecomm"
				/>
				<label for="ecomm">{{ ecomm.text }}</label>
			</div>
			
			<button @click="openPopup3 = true" class="btn_term_view">보기</button>
		</li> -->
		<li>
			<div class="d_check">
				<input type="checkbox" v-model="marketing.checked" @change="updateMarketingSubOptions" id="marketing" />
				<label for="marketing">{{ marketing.text }}</label>
			</div>
			<button @click=openPopup4 class="btn_term_view">보기</button>
		</li>
	</ul>

	<div class="marketing_check_area">
		<div class="d_check">
			<input type="checkbox" v-model="marketing.emailChecked" id="email" @change="updateMarketingChecked" />
			<label for="email">카카오톡</label>
		</div>

		<div class="d_check">
			<input type="checkbox" v-model="marketing.smsChecked" id="sms" @change="updateMarketingChecked" />
			<label for="sms">문자</label>
		</div>

		<p class="marketing_noti">하이비타민의 통합 혜택 및 이벤트 안내를 카카오톡/문자로 받아보실 수 있습니다.</p>
	</div>

	<LayerPopup v-model="showPopup1" title="서비스 이용약관">
		<template #layer_content>
			<div class="layer_term_area" v-html="serviceTermsContent">

			</div>
		</template>
	</LayerPopup>

	<LayerPopup v-model="showPopup2" title="개인정보 처리방침">
		<template #layer_content>
			<div class="layer_term_area" v-html="privacyPolicyContent">
			</div>
		</template>
	</LayerPopup>

	<LayerPopup v-model="showPopup3" title="전자상거래 이용약관">
		<template #layer_content>
			<div class="layer_term_area" v-html="ecommerceTermsContent">
			</div>
		</template>
	</LayerPopup>

	<LayerPopup v-model="showPopup4" title="통합 마케팅 정보 수신 동의">
		<template #layer_content>
			<div class="layer_term_area" v-html="marketingTermsContent">
			</div>
		</template>
	</LayerPopup>
</template>

<script>
import LayerPopup from '@/components/LayerPopup'
import { ref, watch, nextTick } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { getAxios } from '@/lib/AxiosCall';

export default {
	name: 'CheckBoxTerm',
	components: {
		LayerPopup
	},
	data() {
		return {
			terms: {
				text: '[필수] 이용 약관 동의',
				checked: true,
			},
			privacy: {
				text: '[필수] 개인정보 취급방침 동의',
				checked: true,
			},
			ecomm: {
				text: '[필수] 전자상거래 이용약관',
				checked: true,
			},
			marketing: {
				text: '[선택] 통합 마케팅 정보 수신 동의',
				checked: true,
				emailChecked: true,  // 이메일 동의 상태
				smsChecked: true,    // 문자 동의 상태
			},
			allChecked: true, // 전체 동의 체크 상태
			showPopup1: false,
			showPopup2: false,
			showPopup3: false,
			showPopup4: false,
			serviceTermsContent: '',
			privacyPolicyContent: '',
			ecommerceTermsContent: '',
			marketingTermsContent: ''
		};
	},
	setup(props, { expose }) {

		let serviceTerms;

		const checkBoxData = {
			termsChecked: true,
			privacyChecked: true,
			ecommChecked: true,
			emailChecked: true,
			smsChecked: true
		};

		sessionStorage.setItem('termsChecked', true);
		sessionStorage.setItem('privacyChecked', true);
		sessionStorage.setItem('ecommChecked', true);
		sessionStorage.setItem('emailChecked', true);
		sessionStorage.setItem('smsChecked', true);


		const termsReqData = ref({
			contractType: 'CONTRACT_AGREEMENT',
			disp: 'member'
		});

		const termsData = useQuery({
			queryKey: ['get-branch-store', new Date().getTime(), termsReqData.value],
			queryFn: () => getAxios("/hvm/v1/help/contract", termsReqData.value),
			enabled: true,
		});
		termsData.refetch();

		watch(() => termsData.data.value, (newData) => {
			if (newData && newData.page && newData.page.list) {
				sessionStorage.setItem('serviceTermsContent', newData.page.list[0].rmks);
			}
		});

		const privacyReqData = ref({
			contractType: 'CONTRACT_PRIVACY',
			disp: 'member'
		});

		const privacyData = useQuery({
			queryKey: ['get-branch-store', new Date().getTime(), privacyReqData.value],
			queryFn: () => getAxios("/hvm/v1/help/contract", privacyReqData.value),
			enabled: true,
		});
		privacyData.refetch();

		watch(() => privacyData.data.value, (newData) => {
			if (newData && newData.page && newData.page.list) {
				sessionStorage.setItem('privacyPolicyContent', newData.page.list[0].rmks);
			}
		});

		const marketingReqData = ref({
			contractType: 'CONTRACT_MARKETING',
			disp: 'member'
		});

		const marketingData = useQuery({
			queryKey: ['get-branch-store', new Date().getTime(), marketingReqData.value],
			queryFn: () => getAxios("/hvm/v1/help/contract", marketingReqData.value),
			enabled: true,
		});
		marketingData.refetch();

		watch(() => marketingData.data.value, (newData) => {
			if (newData && newData.page && newData.page.list) {
				sessionStorage.setItem('marketingTermsContent', newData.page.list[0].rmks);
			}
		});



		// checkBoxData를 외부에 노출시킴 
		expose({
			checkBoxData
		});
		return {
			checkBoxData,
			serviceTerms
		};
	},
	watch: {
		// 개별 체크박스 상태를 감시하여 전체 동의 상태를 업데이트
		'terms.checked': 'updateAllChecked',
		'privacy.checked': 'updateAllChecked',
		'ecomm.checked': 'updateAllChecked',
		'marketing.checked': 'updateAllChecked',
		'marketing.emailChecked': 'updateAllChecked',
		'marketing.smsChecked': 'updateAllChecked',
	},
	methods: {
		updatePopupContent(popupId, content) {
			nextTick(() => {
				this[popupId] = content;
			});
		},
		openPopup1() {
			this.showPopup1 = true;
			this.updatePopupContent('serviceTermsContent', sessionStorage.getItem('serviceTermsContent'));
		},
		openPopup2() {
			this.showPopup2 = true;
			this.updatePopupContent('privacyPolicyContent', sessionStorage.getItem('privacyPolicyContent'));
		},
		openPopup3() {
			this.showPopup3 = true;
			this.updatePopupContent('serviceTermsContent', sessionStorage.getItem('serviceTermsContent'));
		},
		openPopup4() {
			this.showPopup4 = true;
			this.updatePopupContent('marketingTermsContent', sessionStorage.getItem('marketingTermsContent'));
		},
		initCheckBox() {
			//this.terms.checked = true;
		},
		// 전체 동의 체크박스가 변경되었을 때 모든 체크박스 상태를 업데이트
		toggleAll() {
			const checkStatus = this.allChecked;
			this.terms.checked = checkStatus;
			this.privacy.checked = checkStatus;
			this.ecomm.checked = checkStatus;
			this.marketing.checked = checkStatus;
			this.marketing.emailChecked = checkStatus;
			this.marketing.smsChecked = checkStatus;
		},
		// 마케팅 동의 체크박스가 해제되면 이메일 및 문자 동의 체크박스도 해제
		updateMarketingSubOptions() {
			if (!this.marketing.checked) {
				this.marketing.emailChecked = false;
				this.marketing.smsChecked = false;

				console.log(this.marketing.emailChecked);
				console.log(this.marketing.smsChecked);
				sessionStorage.setItem('emailChecked', false);
				sessionStorage.setItem('smsChecked', false);
			}
			else {

				console.log(this.marketing.emailChecked);
				console.log(this.marketing.smsChecked);
				sessionStorage.setItem('emailChecked', this.marketing.emailChecked);
				sessionStorage.setItem('smsChecked', this.marketing.smsChecked);

				this.marketing.emailChecked = true;
				this.marketing.smsChecked = true;
			}
			this.updateAllChecked();
		},
		// 마케팅 세부 항목(이메일, 문자) 중 하나라도 체크되면 마케팅 동의 체크
		updateMarketingChecked() {
			if (this.marketing.emailChecked || this.marketing.smsChecked) {
				console.log(this.marketing.emailChecked);
				console.log(this.marketing.smsChecked);
				sessionStorage.setItem('emailChecked', this.marketing.emailChecked);
				sessionStorage.setItem('smsChecked', this.marketing.smsChecked);

				this.marketing.checked = true;

				console.log(this.ecomm.checked);
				sessionStorage.setItem('ecommChecked', this.marketing.checked);
			} else {
				this.marketing.checked = false;
				console.log(this.marketing.emailChecked);
				console.log(this.marketing.smsChecked);
				sessionStorage.setItem('emailChecked', false);
				sessionStorage.setItem('smsChecked', false);
			}
			this.updateAllChecked();
		},
		// 필수 약관동의
		updateTermsChecked() {
			this.checkBoxData.termsChecked = true;
			console.log(this.terms.checked);
			sessionStorage.setItem('termsChecked', this.terms.checked);
		},
		// 개인정보 이용동의
		updatePrivacyChecked() {
			console.log(this.privacy.checked);
			sessionStorage.setItem('privacyChecked', this.privacy.checked);
		},
		// 전자상거래 이용동의
		updateEcommChecked() {
			console.log(this.ecomm.checked);
			sessionStorage.setItem('ecommChecked', this.ecomm.checked);
		},
		// 개별 체크박스 상태가 변경될 때 전체 동의 상태를 업데이트
		updateAllChecked() {
			this.allChecked =
				this.terms.checked &&
				this.privacy.checked &&
				this.ecomm.checked &&
				this.marketing.checked &&
				this.marketing.emailChecked &&
				this.marketing.smsChecked;

			sessionStorage.setItem('termsChecked', this.terms.checked);
			sessionStorage.setItem('privacyChecked', this.privacy.checked);
			sessionStorage.setItem('ecommChecked', this.ecomm.checked);
			sessionStorage.setItem('emailChecked', this.marketing.emailChecked);
			sessionStorage.setItem('smsChecked', this.marketing.smsChecked);
		},
	},
};
</script>

<style scoped>
:deep(.layer_bg .layer_popup .title_layer) {
	height: 52px;
	font-size: 22px;
	line-height: 52px;
}

:deep(.layer_bg .layer_popup .btn_close) {
	top: 14px;
}

@media only screen and (max-width: 1023px) {
	:deep(.layer_bg .layer_popup .content) {
		height: calc(100% - 52px);
	}
}
</style>